import React from 'react';
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom';
import { getIsAllSubscrExpired } from '../redux/features/userSlice';

const ProtectedRoute = ({ component: Component, moduleName, userModules, skipDimOverlay, ...rest }) => {

    const userSlice = useSelector((state) => state.user)
    const getModuleAccess = userModules?.find(module => module.name === moduleName && module.read);
    const isSubscriptionExpired = useSelector(getIsAllSubscrExpired);

    return (
        getModuleAccess ?
            <div style={{ pointerEvents: isSubscriptionExpired ? (skipDimOverlay ? 'auto' : 'none') : 'auto', opacity: isSubscriptionExpired ? (skipDimOverlay ? 1 : 0.4) : 1 }}>
                <Component />
            </div>
            : userSlice.role !== 'Tenant' ?
                <Navigate to='/dashboard' />
                : <Navigate to='/tenant-dashboard' />
    );
};

export default ProtectedRoute;
